import { apiPost } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';

export async function postGenerateInvoiceRowsByTextract(invoiceId: string): Promise<any> {
    const response = await apiPost('/api/admin/textract/purchaseinvoice', { invoiceId });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
